namespace app.support.messaging {
    'use strict';
    
    import IToastService = angular.material.IToastService;
    import INotification = app.notification.INotification;
    
    export class MessagesService {
        
        private static DEFAULT_HIDE_DELAY: number = 3000;
        private static TASK_HIDE_DELAY: number = 10000;
        private static DEFAULT_POSITION: string = 'bottom left';
        private static SUCCESS_THEME: string = 'success-toast';
        private static WARNING_THEME: string = 'warn-toast';
        private static ERROR_THEME: string = 'error-toast';
        private static TASK_THEME: string = 'task-toast';
        private static INFO_THEME: string = 'info-toast';
        private static PARENT: string = '#content';
        
        private promise: ng.IPromise<any>;
        
        /** ngInject **/
        constructor(private $mdToast: IToastService, $q: ng.IQService) { 
            this.promise = $q.resolve();
        }
        
        /**
         * Mostra a(s) mensagem(ns) de erro. 
         */
        public error(messages: string | string[], hideDelay?: number, position?: string): ng.IPromise<any> {
            if (angular.isArray(messages)) {
                for (let message of messages) {
                    this.showToast(message, MessagesService.ERROR_THEME, hideDelay, position);
                }
                return this.promise;
            } else {
                return this.showToast(<string> messages, MessagesService.ERROR_THEME, hideDelay, position);
            }
        }

        /**
         * Mostra uma mensagem de sucesso.
         */
        public success(message: string, hideDelay?: number, position?: string): ng.IPromise<any> {
            return this.showToast(message, MessagesService.SUCCESS_THEME, hideDelay, position);
        }

        /**
         * Mostra uma mensagem de atenção.
         */
        public warn(message: string, hideDelay?: number, position?: string): ng.IPromise<any> {
            return this.showToast(message, MessagesService.WARNING_THEME, hideDelay, position);
        }
        
        /**
         * Mostra uma mensagem de informação.
         */
        public info(message: string, hideDelay?: number, position?: string): ng.IPromise<any> {
            return this.showToast(message, MessagesService.INFO_THEME, hideDelay, position);
        }
        
        /**
         * Mostra uma mensagem ação sobre uma tarefa. 
         */
        public task(title: string, action: string): ng.IPromise<string> {
            let toastPreset = this.$mdToast
                .simple()
                .textContent(title)
                .action(action)
                .position(MessagesService.DEFAULT_POSITION)
                .hideDelay(MessagesService.TASK_HIDE_DELAY);

            return this.$mdToast.show(toastPreset);
        }
        
        /**
         * Esconde a mensagem imadiatamente.
         */	    
        public hideMessage(): void {
            this.$mdToast.hide();
        }

        /**
         * Mostra uma mensagem.
         */
        private showToast(message: string, theme: string,
                hideDelay: number = MessagesService.DEFAULT_HIDE_DELAY, position: string = MessagesService.DEFAULT_POSITION): ng.IPromise<any> {
            this.promise = this.promise.finally(() => {
                
                let toastPreset = this.$mdToast
                    .simple()
                    .textContent(message)
                    .position(position)
                    .theme(theme)
                    .hideDelay(hideDelay);
                
                if (position !== MessagesService.DEFAULT_POSITION) {
                    toastPreset.parent(MessagesService.PARENT);
                }    
                
                return this.$mdToast.show(toastPreset);
            });
            return this.promise;
        }
        
    }
    
    angular.module('app.support.messaging').service('messagesService', MessagesService);
}